import React from 'react';

const ProjectPasswordStrengthIndicator = ({ password, showTitle = true }) => {
  if (!password) return null;

  const requirements = [
    {
      text: 'At least 6 characters',
      test: password.length >= 6
    },
    {
      text: 'At least one letter',
      test: /[A-Za-z]/.test(password)
    },
    {
      text: 'At least one number',
      test: /[0-9]/.test(password)
    }
  ];

  return (
    <div className="password-requirements" style={{ marginTop: '8px', fontSize: '0.85rem' }}>
      {showTitle && (
        <div style={{ marginBottom: '6px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          Project Password Requirements:
        </div>
      )}
      {requirements.map((requirement, index) => (
        <div key={index} className={`requirement ${requirement.test ? 'met' : 'unmet'}`}>
          <i className={`fas ${requirement.test ? 'fa-check' : 'fa-times'}`}></i>
          {requirement.text}
        </div>
      ))}
    </div>
  );
};

export default ProjectPasswordStrengthIndicator;
